/* tslint:disable */
/* eslint-disable */
/**
 * LPPSWebApi
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { formatDateOnly, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ProductStatusFilter
 */
export interface ProductStatusFilter {
    /**
     * 
     * @type {boolean}
     * @memberof ProductStatusFilter
     */
    firstHalfYear?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ProductStatusFilter
     */
    secondHalfYear?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ProductStatusFilter
     */
    carryOvers?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ProductStatusFilter
     */
    outgoing?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ProductStatusFilter
     */
    readonly isEmpty?: boolean;
}

/**
 * Check if a given object implements the ProductStatusFilter interface.
 */
export function instanceOfProductStatusFilter(value: object): value is ProductStatusFilter {
    return true;
}

export function ProductStatusFilterFromJSON(json: any): ProductStatusFilter {
    return ProductStatusFilterFromJSONTyped(json, false);
}

export function ProductStatusFilterFromJSONTyped(json: any, ignoreDiscriminator: boolean): ProductStatusFilter {
    if (json == null) {
        return json;
    }
    return {
        
        'firstHalfYear': json['firstHalfYear'] == null ? undefined : json['firstHalfYear'],
        'secondHalfYear': json['secondHalfYear'] == null ? undefined : json['secondHalfYear'],
        'carryOvers': json['carryOvers'] == null ? undefined : json['carryOvers'],
        'outgoing': json['outgoing'] == null ? undefined : json['outgoing'],
        'isEmpty': json['isEmpty'] == null ? undefined : json['isEmpty'],
    };
}

export function ProductStatusFilterToJSON(json: any): ProductStatusFilter {
    return ProductStatusFilterToJSONTyped(json, false);
}

export function ProductStatusFilterToJSONTyped(value?: Omit<ProductStatusFilter, 'isEmpty'> | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'firstHalfYear': value['firstHalfYear'],
        'secondHalfYear': value['secondHalfYear'],
        'carryOvers': value['carryOvers'],
        'outgoing': value['outgoing'],
    };
}

